import { Component, Input } from '@angular/core';
import { OriginalFare } from 'src/app/core/models/cancellation.model';
import { ExchangeFare } from 'src/app/core/models/voluntary-change.model';
import { Price } from 'src/app/core/models/cancellation.model';

@Component({
  selector: 'app-exchange-fare-detail',
  templateUrl: './exchange-fare-detail.component.html',
  styleUrls: ['./exchange-fare-detail.component.scss']
})
export class ExchangeFareDetailComponent {
  @Input() originalFare: OriginalFare;
  @Input() exchangeFare: ExchangeFare;
  @Input() isAirline: boolean;
  @Input() exchangeSeatsAmount: Price;
  @Input() exchangeTotalAmount: Price;
  @Input() fbCodes: string[];

  mapCharges(charges: ExchangeFare) {
    if (
      (this.isAirline && charges?.fixedChargesPriceSummary?.isPricePerReservation === false) ||
      !this.isAirline
    ) {
      charges?.fixedChargeSummaries.forEach((values) => {
        values.totalAmount.amount = charges.fixedChargesPriceSummary.pricePerPassenger.amount;
      });
      return charges?.fixedChargeSummaries;
    }
  }
}
